<app-wrapper>
  <div class="mb-9">
    <div class="mb-4">
      <div class="row g-3">
        <div class="col-auto">
          <h2>
            Слайдер
          </h2>
        </div>
      </div>
    </div>
    <div class="card p-4 mb-4">
      <div class="card-content">
        <div class="row g-5">
          <div class="col-12">
            <h3>Новый слайд</h3>
            <form #newForm="ngForm">
              <div class="row">
                <div class="col-md-4">
                  <div class="image mb-2 me-2">
                    @if (!newSlidePath) {
                      <label>
                        <div class="file-square">
                          <input type="file" id="file" accept="image/*"
                            (change)="selectFile($event)" required />
                            <label for="file">
                              <i class="fa-solid fa-plus"></i>
                            </label>
                          </div>
                        </label>
                      }
                      @if (newSlidePath) {
                        <img [src]="newSlidePath" />
                      }
                    </div>
                    <textarea class="form-control mb-2" [(ngModel)]="newSlideContent" required=""
                    name="new_slide_content"></textarea>

                    <button class="btn btn-primary" (click)="saveNewSlide()" [disabled]="isAdding || newForm.invalid">
                      @if (isAdding) {
                        <span><i class="fa-solid fa-spin fa-spinner"></i>&nbsp;</span>
                        }Добавить
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div class="card p-4">
          <div class="row">
            <div class="col-12">
              <form #form="ngForm">
                <div class="row">
                  @for (image of slides; track image) {
                    <div class="col-md-4 mb-4">
                      <div class="d-flex justify-content-center">
                        <img [src]="image.path" class="w-100" />
                      </div>
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="ps-3 p-2 cursor-pointer" (click)="moveSlide(image, true)">
                          <i class="fa-solid fa-arrow-left"></i>
                        </div>
                        <button class="btn btn-danger m-2" (click)="removeSlide(image)">
                          Удалить
                        </button>
                        <div class="p-2 pe-3 cursor-pointer" (click)="moveSlide(image, false)">
                          <i class="fa-solid fa-arrow-right"></i>
                        </div>
                      </div>
                      <textarea class="form-control" [(ngModel)]="image.content" required=""
                      name="slide_content_{{image.id}}"></textarea>
                    </div>
                  }
                </div>
              </form>

            </div>
            <div class="col-12">
              <button class="btn btn-primary w-auto" (click)="save()" [disabled]="isBusy || form.invalid">
                @if (isBusy) {
                  <span><i class="fa-solid fa-spin fa-spinner" ></i>&nbsp;</span>
                  }Сохранить
                </button>
              </div>
            </div>
          </div>
        </div>
      </app-wrapper>